<template>
	<section class="card">
		<div class="card-content">
			<div class="card-content-header">
				<div class="card-content-header-type" :class="{ 'active-integration': active }" :style="uiIntegrationTypeStyle">
					{{ data.integration }}
				</div>
				<div class="card-content-header-icon" :class="{ 'active-icon': active }">
					<em class="far fa-dot-circle" />
				</div>
			</div>
			<div class="card-content-company">
				<div class="card-content-company-name">{{ data.title }}</div>
				<div class="card-content-company-subname">{{ data.subtitle }}</div>
			</div>
			<div class="card-content-product">
				<div :class="{ 'active-products': active }" class="card-content-product-integration">
					Empreendimentos Integrados: {{ data.integrated_products }}
				</div>
				<div class="card-content-product-icon">
					<ui-menu-card icon="fal fa-cog" card-design="blue-dot">
						<slot />
					</ui-menu-card>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import { uiMenuCard } from '@/components/ui'

import { erp } from '@/services/axios'

export default {
	name: 'card-erp',
	components: {
		uiMenuCard,
	},

	props: {
		data: {
			type: [Array, Object],
			required: true,
		},
	},

	data() {
		return {
			active: false
		}
	},

	computed: {
		uiIntegrationTypeStyle(){
			const type = this.data.integration || ''
			return { 'text-transform': type.trim().length <= 3 ? 'uppercase' : 'capitalize' }
		}
	},

	mounted() {
		this.checkConnection()
	},

	methods: {
		checkConnection() {
			erp.createV2('check', this.data.connection_params)
				.then(response => {
					if (response.data.data) {
						this.active = response.data.data.connected

					} else {
						this.active = response.data.data
					}
				})
				.catch(error => {
					if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					console.log(error)
				})
		},
	}
}
</script>

<style lang='stylus' scoped>
@import './styles.styl';
</style>
